import{asChildPropDef as s}from"../props/as-child.prop.js";const e=["1","2","3","4","5","6","7","8","9"],o={...s,size:{type:"enum",className:"rt-r-size",values:e,responsive:!0}};export{o as kbdPropDefs};
//# sourceMappingURL=kbd.props.js.map
